import React from "react";

import { useListPlanningRuns, type PlanningRun } from "@/api/planningRun";

interface PlanLensValue {
  /** The lens run; null when the lens is off or its run is gone. */
  run: PlanningRun | null;
  runs: PlanningRun[];
  setRunId: (id: number | null) => void;
}

const PlanLensContext = React.createContext<PlanLensValue | null>(null);

/** Held in memory, not the URL: links across the app needn't carry it, and a
 *  reload turns the lens off. */
export function PlanLensProvider(props: { children: React.ReactNode }) {
  const [runId, setRunId] = React.useState<number | null>(null);
  // ponytail: the newest 20 runs; an older run can't be put under the lens.
  const runs =
    useListPlanningRuns({ limit: 20, offset: 0 }).data?.results ?? [];
  const run = runs.find((r) => r.id === runId) ?? null;

  return (
    <PlanLensContext.Provider value={{ run, runs, setRunId }}>
      {props.children}
    </PlanLensContext.Provider>
  );
}

export function usePlanLens(): PlanLensValue {
  const ctx = React.useContext(PlanLensContext);
  if (!ctx) throw new Error("usePlanLens must be used within PlanLensProvider");
  return ctx;
}
